export default __webpack_public_path__ + "static/media/twitter-square-brands.763ddc74.svg";